import { CustomHeader } from 'components/universal/custom-header';
import { useTranslation } from 'react-i18next';
import { ConfirmEmailAddressView } from 'views/confirm-email-address';

export const ConfirmEmailAddress = () => {
    const { t } = useTranslation('', {
        keyPrefix: 'SEO.confirmResetPassword',
    });
    
    return (
        <div>
            <CustomHeader title={t('title')} />
            <ConfirmEmailAddressView />
        </div>
    );
};
